// @ts-nocheck
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    PreloadData,
} from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, PreloadData, props => {
    const state = props.getState();
    const cartState = getCartState(state, props.parameter.cartId);
    if (!cartState.value && !cartState.isLoading) {
        const promotionsState = getPromotionsDataView(state, props.parameter.cartId);
        const shouldLoadPromotions = !promotionsState.value && !promotionsState.isLoading;
        props.dispatch(
            loadCart({
                cartId: props.parameter.cartId,
                getPromotions: shouldLoadPromotions,
                shouldLoadFullCart: true,
                // Store Custom Code - this comes from client-framework\src\Store\Data\Carts\Handlers\LoadCart.ts in PopulateApiParameter
                apiParameter: {
                    cartId: props.parameter.cartId,
                    forceRecalculation: true,
                    allowInvalidAddress: true,
                    expand: [
                        "validation",
                        "cartLines",
                        "restrictions",
                        "shipping",
                        "tax",
                        "carriers",
                        "paymentOptions",
                        "creditCardBillingAddress",
                        "costCodes",
                    ],
                },
            }),
        );
    }
});
